import { Route, Routes } from 'react-router-dom';

import NotFound from '../screens/Auth/NotFound';
import { ShareScreen } from '../screens/Share/ShareScreen';
// import { ShareJoinClubScreen } from '../screens/Share/ShareJoinClubScreen';
// import { ShareGameScreen } from '../screens/Share/ShareGameScreen';
// import { ShareJoinLeaderboardTeamScreen } from '../screens/Share/ShareJoinLeaderboardTeamScreen';

const ShareRoute: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<ShareScreen />} />
      {/* <Route path="/join-club" element={<ShareJoinClubScreen />} /> */}
      {/* <Route path="/game" element={<ShareGameScreen />} /> */}
      {/* <Route
        path="/join-leaderboard-team"
        element={<ShareJoinLeaderboardTeamScreen />}
      /> */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default ShareRoute;
